import React, { useEffect, useState } from "react";
import "./Capturing_Success_Stories.css";
import { FaMapMarkerAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Gallerys } from "../../../utils/apis/gallery/Gallery";
import { IDS } from "../../../utils/common";

const Card = ({ id, mainImage, thumbs = [], name, description }) => {
  const navigate = useNavigate();

  const HtmlToReactParser = require("html-to-react").Parser;
  const htmlToReactParser = new HtmlToReactParser();

  const handleRedirect = () => {
    navigate(`/gallery-inner/${id}`);
  };

  return (
    <div
      className="success-card"
      onClick={handleRedirect}
      style={{ cursor: "pointer" }}
    >
      <div className="success_div">
        <img
          src={IDS?.IMG_URL + mainImage}
          alt="project"
          className="card-main-img"
        />
      </div>

      <div className="thumb-stack">
        {thumbs.map((img, index) => (
          <img key={index} src={IDS?.IMG_URL + img} alt="thumb" />
        ))}
      </div>

      <div className="card-overlay">
        <div>
          <div className="location">
            <FaMapMarkerAlt />
            <span>{name}</span>
            <i className="fa fa-chevron-circle-right"></i>
          </div>

          <p>{description ? htmlToReactParser.parse(description) : ""}</p>

          <div className="image-count">
            <img
              src="/assets/images/gallery/img_count.png"
              alt="count"
              className="img_count"
            />
            <span>+{thumbs.length}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const CapturingSuccessStories = () => {
  const [gallery, setGallery] = useState([]);

  const getGallery = async () => {
    const res = await Gallerys();

    if (res?.success) {
      setGallery(res?.data || []);
    }
  };

  useEffect(() => {
    getGallery();
  }, []);

  return (
    <section className="success-section">
      <h2>Capturing Success Stories</h2>

      <p className="subtitle">
        Every picture reflects growth, confidence, and achievement.
      </p>

      <div className="card-container">
        {gallery.map((item) => (
          <Card
            key={item.id}
            id={item.id}
            mainImage={item.image}
            name={item.name}
            description={item.description}
            thumbs={
              item?.GalleryImages?.slice(0, 4).map(
                (img) => img.gallery_images,
              ) || []
            }
          />
        ))}
      </div>
    </section>
  );
};

export default CapturingSuccessStories;
